module.exports = __webpack_public_path__ + "img/schmetterling.f6646b96.png";